import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button";
import "./patientQrDialog.css"

const PatientQrDialog = ({ visible, patient, onHide, t }: any) => {

    const getQrImageSrc = () => {
        const qrImageBase64 = patient?.qrImageBase64;
        if (!qrImageBase64) return null;

        return qrImageBase64.startsWith("data:") ? qrImageBase64 : `data:image/png;base64,${qrImageBase64}`;
    }

    const qrImageSrc = getQrImageSrc();

    return (
        <Dialog
            className="patient-qr-dialog"
            maskClassName="patient-qr-dialog-mask"
            visible={visible}
            style={{ width: '22rem', maxWidth: 'calc(100vw - 2rem)', borderRadius: '24px', overflow: "hidden", padding: 0 }}
            onHide={onHide}
            showHeader={false}
            dismissableMask
        >
            <div className="flex flex-column align-items-center p-4 pb-5 gap-3" style={{
                background: '#2D3967',
                backgroundImage: "url('/codeCardPattern.png')",
                backgroundRepeat: "no-repeat"
            }}>
                <div className="flex justify-content-end w-full">
                    <Button className="p-button-rounded p-button-text"
                        style={{ color: 'white', width: "2rem", height: "2rem", display: "flex", justifyContent: "center" }}
                        onClick={onHide}>
                        <img src="/cancelWhite.svg" />
                    </Button>
                </div>

                <div className="flex flex-column align-items-center">
                    <p className="m-0 text-md" style={{ color: "white" }}>{t("registerCode")}</p>
                    <p className="m-0 text-4xl font-bold" style={{ color: "#CF4961", letterSpacing: "0.15em", lineHeight: 1 }}>{patient?.code}</p>
                </div>

                {qrImageSrc && <div className="patient-qr-dialog-or">
                    <span>{t("or")}</span>
                </div>}

                {qrImageSrc && <div className="patient-qr-dialog-qr">
                    <img src={qrImageSrc} alt="QR" />
                </div>}
            </div>
        </Dialog>
    )
}

export default PatientQrDialog;
